module.exports = __webpack_public_path__ + "static/media/back-min.6057303d.jpg";